import axios from "axios"
const controller = "/caja"

const CajaService = {
    cargarDatos: async () => {
        const { data } = await axios.post(`${controller}/cargarDatos`)
        return data
    },
    buscar: async (caja, usuario) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            caja,
            usuario
        })
        return data
    },
    registrar: async (caja) => {
        const { data } = await axios.post(`${controller}/registrar`, { caja })
        return data
    },
    editar: async (caja) => {
        const { data } = await axios.post(`${controller}/editar`, { caja })
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    solicitarAprobacionCaja: async (caja) => {
        const { data } = await axios.post(`${controller}/solicitarAprobacionCaja`, { caja })
        return data
    },
    aprobar: async (caja) => {
        const { data } = await axios.post(`${controller}/aprobar`, {
            caja
        })
        return data
    },
    desaprobar: async (caja) => {
        const { data } = await axios.post(`${controller}/desaprobar`, { caja })
        return data
    },
    depositar: async (caja) => {
        const { data } = await axios.post(`${controller}/depositar`, { caja })
        return data
    },
    cancelar: async (caja) => {
        const { data } = await axios.post(`${controller}/cancelar`, { caja })
        return data
    },
    generarReporteCaja: async (request) => {
        const { data } = await axios.post(`${controller}/generarReporteCaja`, request)
        return data
    },
}
export default CajaService